import angular from 'angular';
import teamRequestCardActionsMobileComponent from './teamRequestCardActionsMobile.component';

let teamRequestCardActionsMobileModule = angular.module('teamRequestCardActionsMobile', [
])

.component('teamRequestCardActionsMobile', teamRequestCardActionsMobileComponent)

.name;

export default teamRequestCardActionsMobileModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardActionsMobile/teamRequestCardActionsMobile.js